import Box from '@mui/material/Box';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import DeleteIcon from '@mui/icons-material/DeleteOutline';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AvailabilityListItem from './AvailabilityListItem';
import EditAvailabilityForm from './EditAvailabilityForm';
import { 
  useRemoveProviderAvailabilityMutation 
} from '../../redux/services/providerAvailabilityApi';


const handleDelete = ({remove, onSelectAvailability}) => async (e, id) => {
  if (window.confirm('Are you sure you want to delete this availability?')) {
    const response = await remove({id});
    if (!response.error) onSelectAvailability(null);
  }
};

const AvailabilitySidePane = ({ 
  availabilities, 
  selectedAvailability,
  onSelectAvailability,
  boxStyles 
}) => {
  const [remove] = useRemoveProviderAvailabilityMutation();
  const onDelete = handleDelete({remove, onSelectAvailability});
  return (
    <Box sx={{...boxStyles, p: 0, width: 300}}>
      <Stack spacing={1} p={2}>
        <Stack 
          direction='row' 
          alignItems='center'
          justifyContent='space-between'
        >
          <Stack direction='row' alignItems='center'>
            {selectedAvailability && 
              <IconButton
                color='primary'
                onClick={() => onSelectAvailability(null)}
              >
                <ChevronLeftIcon />
              </IconButton>
            }
            <Typography variant='h2'>
              {selectedAvailability ? 'Zone Details' : 'Availability Zones'}
            </Typography>
          </Stack>
          {selectedAvailability && 
            <IconButton
              color='error'
              onClick={e => onDelete(e, selectedAvailability)}
            >
              <DeleteIcon />
            </IconButton>
          }
        </Stack>
        {!selectedAvailability && 
          <Typography variant='body1' color='text.muted'>
            {availabilities?.length || 0} zone{availabilities?.length === 1 ? '' : 's'} configured
          </Typography>
        }
      </Stack>
      <Divider />
      <Stack>
        {availabilities?.length ?
          <Box 
            key={`editing-${selectedAvailability}`}
            style={{padding: '0.75em'}}
          >
            {
              selectedAvailability 
              ? <EditAvailabilityForm
                  availability={availabilities.find(a => a.id === selectedAvailability)}
              />
              : availabilities.map(a => 
                <Box mt={2.0}>
                  <AvailabilityListItem 
                    availability={a}
                    onClick={e => onSelectAvailability(a.id)}
                  />
                </Box>
              )
            }
          </Box>
        :
          <Typography variant='body1' sx={{p: 2}}>
            No availability zones configured. Create zones to specify when and where you are available for appointments.
          </Typography>
        }
      </Stack>
    </Box>
  );
};

export default AvailabilitySidePane;